// extracted by mini-css-extract-plugin
export var label = "_cs-2";
export var slideContainer = "_cs-0";
export var slider = "_cs-1";